import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GrupoImportadorService } from '../grupo-importador-service/grupo.importador.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';
import { Estado } from './../../../../shared/shared/estado.enum';

@Component({
  selector: 'app-grupo-importador-cadastro',
  templateUrl: './grupo-importador-cadastro.component.html',
  styleUrls: ['./grupo-importador-cadastro.component.css']
})
export class GrupoImportadorCadastroComponent
extends CrudBase
implements OnInit {

constructor(
  service: GrupoImportadorService,
  toastr: ToastrService
) {
  super(service, toastr);
}

ngOnInit() {
  if (!this.model) {
    this.model = {};
  }
  this.defineModelVazio();
}

novo() {
  super.novo();
  this.defineModelVazio();
}

// == [ INICIO: Métodos Auxiliares ] ==
private defineModelVazio() {
  if (this.state === Estado.insert) {
    this.model.id = null;
  }
}
// == [ FIM:    Métodos Auxiliares ] ==

}
